import { memo } from 'react';

function NoFreightMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.2199 18V6L12.8299 0L2.43994 6V18L12.8299 24L23.2199 18Z"
        fill={backgroundColor}
      />
      <path
        d="M12.8299 1.15L22.2199 6.57V17.42L12.8299 22.84L3.43994 17.42V6.58L12.8299 1.15ZM12.8299 0L2.43994 6V18L12.8299 24L23.2199 18V6L12.8299 0Z"
        fill={borderColor}
      />
      <path
        d="M12.8798 7.56689V16.4331H11.4511L7.27348 10.3939H7.19988V16.4331H5.59375V7.56689H7.03104L11.2044 13.6105H11.2823V7.56689H12.8798Z"
        fill={borderColor}
      />
      <path
        d="M14.386 16.4331V7.56689H20.0659V8.91328H15.9922V11.3203H19.6763V12.6667H15.9922V16.4331H14.386Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(NoFreightMarker);
